"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authPlayerContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("../payment/models");
const models_2 = require("./models");
const c = (0, core_1.initContract)();
exports.authPlayerContract = c.router({
    getDetails: {
        method: 'GET',
        path: '/details',
        responses: {
            200: zod_1.z.object({
                player: models_2.ZPlayerSelectPrivateWithHasSocialLogin,
                balances: models_1.ZPlayerAccountSelectPrivate,
                isFtmp: zod_1.z.boolean(),
            }),
            404: c.type(),
        },
        summary: 'Get player details contract',
    },
    updateDetails: {
        method: 'POST',
        path: '/details',
        body: zod_1.z.object({
            player: models_2.ZPlayerUpdate,
        }),
        responses: {
            200: zod_1.z.object({
                player: models_2.ZPlayerSelectPrivateWithHasSocialLogin,
            }),
            400: c.type(),
        },
        summary: 'Update player details for the player specified in the access token',
    },
    changePassword: {
        method: 'POST',
        path: '/change-password',
        body: models_2.ZChangePassword,
        responses: {
            200: zod_1.z.object({
                token: zod_1.z.string(),
            }),
            400: c.type(),
        },
        summary: 'Update password for the player specified in the access token',
    },
    uploadAvatarIcon: {
        method: 'POST',
        path: '/upload-avatar-icon',
        contentType: 'multipart/form-data',
        body: c.type(),
        responses: {
            200: zod_1.z.string(),
            400: c.type(),
        },
    },
}, {
    pathPrefix: '/auth',
    baseHeaders: zod_1.z.object({
        'x-access-token': zod_1.z.string(),
    }),
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=player.auth.contract.js.map